import React from 'react';

export const PolygotsLogo = ({ className = "", size = "default" }) => {
    const sizes = {
        small: { width: "200px", height: "50px" },
        default: { width: "280px", height: "70px" },
        large: { width: "360px", height: "90px" }
    };

    const currentSize = sizes[size] || sizes.default;

    return (
        <div
            className={`relative inline-flex items-center justify-center ${className}`}
            style={{
                width: currentSize.width,
                height: currentSize.height,
                minWidth: currentSize.width
            }}
        >
            {/* Logo with professional styling */}
            <svg
                viewBox="0 0 700 180"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full"
                style={{
                    filter: 'drop-shadow(0 4px 12px rgba(6, 182, 212, 0.4)) drop-shadow(0 0 20px rgba(6, 182, 212, 0.2))'
                }}
            >
                {/* Connection lines/nodes decorations - More prominent */}
                <g className="connection-nodes" stroke="currentColor" strokeWidth="4" fill="none">
                    {/* Top decorative nodes */}
                    <circle cx="120" cy="25" r="8" className="text-cyan-400" fill="currentColor" stroke="none" />
                    <line x1="120" y1="33" x2="120" y2="58" className="text-cyan-400/50" strokeWidth="3" />

                    <circle cx="300" cy="15" r="8" className="text-cyan-400" fill="currentColor" stroke="none" />
                    <line x1="300" y1="23" x2="300" y2="58" className="text-cyan-400/50" strokeWidth="3" />

                    <circle cx="520" cy="20" r="8" className="text-cyan-400" fill="currentColor" stroke="none" />
                    <line x1="520" y1="28" x2="520" y2="58" className="text-cyan-400/50" strokeWidth="3" />

                    {/* Inner nodes with glow effect */}
                    <circle cx="130" cy="100" r="10" className="text-white" fill="currentColor" stroke="none" />
                    <circle cx="130" cy="100" r="15" className="text-cyan-400" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.4" />

                    <circle cx="260" cy="100" r="10" className="text-white" fill="currentColor" stroke="none" />
                    <circle cx="260" cy="100" r="15" className="text-cyan-400" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.4" />

                    <circle cx="440" cy="100" r="10" className="text-white" fill="currentColor" stroke="none" />
                    <circle cx="440" cy="100" r="15" className="text-cyan-400" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.4" />

                    <circle cx="530" cy="100" r="10" className="text-white" fill="currentColor" stroke="none" />
                    <circle cx="530" cy="100" r="15" className="text-cyan-400" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.4" />

                    <circle cx="610" cy="95" r="10" className="text-white" fill="currentColor" stroke="none" />
                    <circle cx="610" cy="95" r="15" className="text-cyan-400" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.4" />

                    {/* Bottom decorative nodes */}
                    <circle cx="360" cy="160" r="8" className="text-cyan-400" fill="currentColor" stroke="none" />
                    <line x1="360" y1="152" x2="360" y2="130" className="text-cyan-400/50" strokeWidth="3" />

                    <circle cx="680" cy="155" r="8" className="text-cyan-400" fill="currentColor" stroke="none" />
                    <line x1="680" y1="147" x2="680" y2="125" className="text-cyan-400/50" strokeWidth="3" />
                </g>

                {/* Main text with gradient effect */}
                <defs>
                    <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
                        <stop offset="50%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
                        <stop offset="100%" style={{ stopColor: '#22d3ee', stopOpacity: 1 }} />
                    </linearGradient>
                </defs>

                <text
                    x="50%"
                    y="52%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    style={{
                        fontSize: '105px',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: 800,
                        letterSpacing: '0.02em',
                        fill: 'url(#textGradient)'
                    }}
                >
                    polyglots
                </text>
            </svg>
        </div>
    );
};

export default PolygotsLogo;
